// File: src/utils/cropImage.js

// Hàm tạo đối tượng Image từ URL
export const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image()
    image.addEventListener('load', () => resolve(image))
    image.addEventListener('error', (error) => reject(error))
    image.setAttribute('crossOrigin', 'anonymous') // Quan trọng để tránh lỗi CORS
    image.src = url
  })

/**
 * Hàm cắt ảnh
 * @param {string} imageSrc - URL ảnh gốc (base64 hoặc đường dẫn)
 * @param {object} pixelCrop - Tọa độ cắt { x, y, width, height }
 * @returns {Promise<Blob>} - Trả về file ảnh dạng Blob
 */
export default async function getCroppedImg(imageSrc, pixelCrop) {
  const image = await createImage(imageSrc)
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')

  // Set kích thước canvas bằng kích thước vùng cắt
  canvas.width = pixelCrop.width
  canvas.height = pixelCrop.height

  // Vẽ ảnh lên canvas theo tọa độ cắt
  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    pixelCrop.width,
    pixelCrop.height
  )

  // ✅ QUAN TRỌNG: Chuyển Canvas thành Blob (File object)
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) {
        // reject(new Error('Canvas is empty'));
        console.error('Canvas is empty');
        return;
      }
      // Gán thêm name để nó giống file thật
      blob.name = 'cropped.jpg';
      resolve(blob);
    }, 'image/jpeg');
  })
}